import groupon from './GrouponHeight';

export default groupon;
